import { useMemo } from 'react'

import { createBusinessRules } from '@ngb-frontend/shared/rules'

import { useAppConfig } from '../AppConfigContext/AppConfigContext'
import { useCountryConfig } from '../CountryConfigContext/CountryConfigContext'
import { useQuery } from '../QueryConfigContext/QueryConfigContext'

import type { BusinessRules } from '@ngb-frontend/shared/types'

/**
 * Centralized business rules resolved for the current session (country,
 * journey, remote country config, app flags). Components branch on the
 * resolved capabilities — never on country or brand identifiers.
 */
export const useBusinessRules = (): BusinessRules => {
  const query = useQuery()
  const countryConfig = useCountryConfig()
  const config = useAppConfig()

  return useMemo(
    () =>
      createBusinessRules({
        countryCode: query?.country,
        journey: query?.journey,
        countryConfig,
        disableDateBlocking: config.disableDateBlocking,
      }),
    [query?.country, query?.journey, countryConfig, config.disableDateBlocking],
  )
}
